import * as React from 'react';

export type EnvelopeIconProps = React.HTMLAttributes<HTMLSpanElement> & {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  /** Defaults to your original SVG fill (#222222) */
  color?: string;
};

function EnvelopeIcon({
  size = 19,
  title = 'Email',
  className,
  style,
  color = '#222222',
  ...spanProps
}: EnvelopeIconProps) {
  // Original SVG is 19x15. Preserve aspect ratio if `size` is a number.
  const width = typeof size === 'number' ? `${size}px` : size;
  const height = typeof size === 'number' ? `${Math.round((size * 15) / 19)}px` : size;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width,
        height,
        lineHeight: 0,
        ...style,
      }}
      {...spanProps}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 19 15'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden
        focusable='false'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.0625 0.9375H2.9375C1.48844 0.939158 0.314158 2.11344 0.3125 3.5625V11.4375C0.314158 12.8866 1.48844 14.0608 2.9375 14.0625H16.0625C17.5116 14.0608 18.6858 12.8866 18.6875 11.4375V3.5625C18.6858 2.11344 17.5116 0.939158 16.0625 0.9375ZM16.0625 2.25C16.176 2.25154 16.2888 2.26799 16.3981 2.29893L11.8533 6.84375H7.14671L2.60189 2.29893C2.71113 2.26799 2.82396 2.25154 2.93749 2.25H16.0625ZM17.375 11.4375C17.3742 12.162 16.7871 12.7492 16.0625 12.75H2.9375C2.21295 12.7492 1.62577 12.162 1.625 11.4375V3.56249C1.62654 3.44896 1.64299 3.33613 1.67393 3.22689L6.21875 7.77171C6.46429 8.01871 6.79845 8.15718 7.14673 8.15624H11.8533C12.2015 8.15718 12.5357 8.01871 12.7813 7.77171L17.3261 3.22689C17.357 3.33613 17.3735 3.44896 17.375 3.56249V11.4375Z'
          fill={color}
        />
      </svg>
    </span>
  );
}

export default EnvelopeIcon;
